import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Articolo, ArticoloFull } from 'src/app/shared/interfaces/custom/articolo';
import { ShopService } from 'src/app/shared/api/shop.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ProductCustomizationComponent } from 'src/app/shared/components/product-customization/product-customization.component';

@Component({
  selector: 'app-food-item',
  templateUrl: './food-item.component.html',
  styleUrls: ['./food-item.component.scss']
})
export class FoodItemComponent {
  @Input() item!: Articolo;
  openingBox = false;

  constructor(
    private router: Router,
    private shopService: ShopService,
    private modalService: BsModalService
  ) {}

  goToProductPage() {
    if (this.openingBox) {
      return;
    }

    if (this.item.tipo_articolo === 5 || this.item.tipo_articolo === 6) {
      this.openingBox = true;

      this.shopService.getArticolo(this.item.codart).subscribe({
        next: articolo => {
          this.shopService.getArticoliComposizione(this.item.codart).subscribe({
            next: composizione => {
              this.openingBox = false;
              this.modalService.show(ProductCustomizationComponent, {
                class: 'modal-dialog-centered modal-xl customized-modal-dialog',
                initialState: {
                  articolo: JSON.parse(JSON.stringify(articolo)),
                  qta: 1,
                  articoli: composizione
                }
              });
            },
            error: () => {
              this.openingBox = false;
              alert('Errore nel caricamento della composizione');
            }
          });
        },
        error: () => {
          this.openingBox = false;
          alert('Errore nel caricamento del prodotto');
        }
      });
      return;
    }

    this.router.navigate(['/menu/product', this.item.codart]);
  }
}
